import React from 'react';
import ReactDOM from 'react-dom';
import Recent from './containers/RecentReviews';

const renderRecentApp = () => {
  const e = document.getElementById('recentReviewsWidget');
  if(e) {
    ReactDOM.render(<Recent {...e.dataset} />, e);
  }
}

renderRecentApp();



// WEBPACK FOOTER //
// ./src/recent.js